import { HDateHour } from "@shared/src/datatypes/HDateHour";
import { HTags } from "@shared/src/datatypes/HTags";
import { HTime } from "@shared/src/datatypes/HTime";
import { GeneralStatus } from '@shared/src/enums/GeneralStatus';
import { ManagementModelResponseStatus } from "@shared/src/enums/ManagementModelResponseStatus";
import { DockDto } from "../address/dock/DockDto";
import { iRouteCard } from "./iRouteCard";
import { IconDto } from "../IconDto";
import { SlotInfoDto } from "../address/slots/SlotInfoDto";

export class RouteCardItemDto implements iRouteCard {
    public routeId: number;
    public routeKey: string;
    public title: string;
    public titleSubtitle: string;
    public subtitle: string;
    public line1: string;
    public line2: string;
    public line3: string;
    public manualTags: HTags;
    public userTags: HTags;
    public internalTags: HTags;
    public privateTags: HTags;
    public allTags: HTags;

    public typology: string;

    public palletCount: number;
    public kilosCount: number;
    public netKilosCount: number;
    public boxesCount: number;
    public bagsCount: number;
    public sacksCount: number;
    public litresCount: number;
    public quantityProduct: number;
    public packetCount: number;
    public productCount: number;
    public shipmentCount: number;
    public groupCount: number;
    public stops: HTags;

    public dateHourFrom: HDateHour;
    public dateHourTo: HDateHour;

    public slotHDateHour: HDateHour;

    public pendingSlotQty: number;
    public assignedSlots: SlotInfoDto[];

    public generalStatus: GeneralStatus;

    public isSlotBlocked: boolean;
    public incompatibleSlot: boolean;
    public isNotRecomendable: boolean;

    public stopCount: number;
    public phaseCount: number;

    public plateA: string;
    public plateB: string;
    public plateC: string;
    public transportationRegistrationCode: string;

    public partnerParentTrademark: string;
    public partnerDriverTrademark: string;
    public partnerSecondDriverTrademark: string;
    public partnerCarrierTrademark: string;
    public partnerShipperTrademark: string;
    public partnerLogisticOperatorTrademark: string;
    public partnerInspectorTrademark: string;
    public partnerHealthCertifierTrademark: string;
    public partnerClientPreferentTrademark: string;

    public iAmObserver: boolean;
    public isDelayed: boolean;

    public docks: Array<DockDto>;

    public pendingMessagesRead: number;

    public isReturn: boolean;
    public isReverseLogistics: boolean;
    public isNonacceptance: boolean;
    public isInbound: boolean;
    public isOutbound: boolean;
    public isDelegate: boolean;

    public isDivided: boolean;
    public isChildOfDivided: boolean;
    public childsCount: number;
    public pendingChildsCount: number;

    public isGrouped: boolean;
    public isChildOfGrouped: boolean;

    public isBrokenForTrucking: boolean;
    public isTrucked: boolean;
    public truckingConfirmed: boolean;

    public isExwork: boolean;

    public bookingId: number;
    public bookingSlotId: number;

    public requiredCertificate: boolean;
    public requiredInspector: boolean;
    public hasSlotReserveMarginTime: boolean;
    public hasBannerHtml: boolean;
    public styledPrivateBannerHtml: string;
    public styledBannerHtml: string;
    public slotReserveMarginTime: HTime;

    public showMMResponseStatus: boolean;
    public responseStatus: ManagementModelResponseStatus;

    public showPalletCountOnRouteCard: boolean;
    public showKilosCountOnRouteCard: boolean;
    public showNetKilosCountOnRouteCard: boolean;
    public showBoxesCountOnRouteCard: boolean;
    public showBagsCountOnRouteCard: boolean;
    public showSacksCountOnRouteCard: boolean;
    public showLitresCountOnRouteCard: boolean;
    public showQuantityProductOnRouteCard: boolean;
    public showPacketCountOnRouteCard: boolean;
    public showProductCountOnRouteCard: boolean;
    public showShipmentCountOnRouteCard: boolean;

    public json: string;

    public icons: Array<IconDto>;
    dummySearchString: string;
}
